import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqhuhu575p: FaireProductEntity = {
  token: "p_kqhuhu575p",
  type: "product",
  name: "Four Leaf Clover Pendant Necklace in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/e690abef499368d0c4157e2bd957382983a4ca319998225193530da665615ea3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5dcfcbb46bb5d25bfb61e6a22daabe22bcc0eda11ccaa8935b0c96c29153f55.png",
    "https://cdn.faire.com/fastly/555928651637e4240725c0f075dd806baaa12022e32237252094eb07bc416e74.png",
    "https://cdn.faire.com/fastly/df70e15001b723f95af29c73555c2b40d8c29d64430cf20600ab2ed99ba950a2.png",
    "https://cdn.faire.com/fastly/ac996f7f703508ffdeec845d43b4deff53e3fe5b24a49db98fab076f0f8fa59c.png",
  ],
  priceDollars: 12.5,
  description:
    "Description & Details\n\nEmbrace the luck and whimsy of the four-leaf clover with our exquisite pieces inspired by this rare and cherished symbol. Each design in our collection is meticulously crafted to capture the beauty and mystique of the four-leaf clover in its finest form.\n\n• Material: Solid 925 Sterling Silver ∙ Cubic Zirconia\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 7 x 7 mm charm, 40 - 45 cm chain, adjustable\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:56.104Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
